/* global angular */
angular.module('ua5App')
    .factory('SocialPostsFactory', ['$resource', '$rootScope', function($resource, $rootScope) {
        return $resource($rootScope.apiDevUrl + 'social-posts');
    }])
;
